<template>
  <swiper effect="fade">
    <swiper-slide>
      Slide 1
    </swiper-slide>
    <swiper-slide>
      Slide 2
    </swiper-slide>
    <swiper-slide>
      Slide 3
    </swiper-slide>
  </swiper>
</template>

<script>
import { defineComponent } from "vue";
import SwiperCore, { EffectFade } from "swiper";
import { Swiper, SwiperSlide } from "swiper/vue";

import "swiper/swiper.scss";
import "swiper/components/effect-fade/effect-fade.scss";

SwiperCore.use([EffectFade]);

const Start = defineComponent({
  name: "Start",
  components: {
    Swiper,
    SwiperSlide
  }
});

export default Start;
</script>

<style scoped></style>
